<ng-template #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ isCreate ? 'COMMON.ADD-CUS' : 'COMMON.EDIT-CUS'|translate}}</h4>
  </div>
  <div class="modal-body box-parent">
    <div class="row">
      <div class="col">
<!--        <div class="dropdown-label-group">-->
<!--          <p-dropdown-->
<!--            class="dv-dropdown"-->
<!--            selectId="buyerType"-->
<!--            [options]="customerTypes"-->
<!--            [(ngModel)]="data.buyerType"-->
<!--            [autoDisplayFirst]="false"-->
<!--            placeholder="ประเภทลูกค้า"-->
<!--          >-->
<!--          </p-dropdown>-->
<!--          <label for="buyerType">ประเภทลูกค้า</label>-->
<!--          <span class="text-danger">{{ errors && errors.buyerType }}</span>-->
<!--        </div>-->

        <div class="form-label-group">
          <input type="text" id="name" class="form-control" [(ngModel)]="data.name" placeholder="{{'NORMAL.COMPANY-NAME'|translate}}">
          <label for="name">{{'NORMAL.CUSTOMER-NAME'|translate}}</label>
          <span class="text-danger">{{ errors && errors.name }}</span>
        </div>

        <div class="form-label-group">
          <input type="text" id="customer_id" class="form-control" [(ngModel)]="data.customerID" placeholder="{{'NORMAL.CUSTOMER-ID'|translate}}">
          <label for="name">{{'NORMAL.CUSTOMER-ID'|translate}}</label>
          <span class="text-danger">{{ errors && errors.customerID }}</span>
        </div>

<!--        <div class="row justify-content-center align-items-center">-->
<!--          <div class="col-md">-->
<!--            <div class="form-label-group m-b-0">-->
<!--              <input type="text" id="branchName" class="form-control" [(ngModel)]="data.branchName" placeholder="{{'TABLE.BRANCH-NAME'|translate}}"-->
<!--                     [disabled]="data.headOffice">-->
<!--              <label for="branchName">{{'TABLE.BRANCH-NAME'|translate}}</label>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-md-auto">-->
<!--            <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="data.headOffice" label="{{'DATA.HEAD-OFFICE'|translate}}"></p-checkbox>-->
<!--          </div>-->
<!--        </div>-->
<!--        <span class="text-danger">{{ errors && errors.branchName }}</span>-->

        <div class="form-label-group" style="margin-top: 1em;">
          <input type="text" id="address" class="form-control" [(ngModel)]="data.address" placeholder="{{'FILTER.ADDRESS'|translate}}่">
          <label for="address">{{'FILTER.ADDRESS'|translate}}</label>
          <span class="text-danger">{{ errors && errors.address }}</span>
        </div>

        <div class="form-label-group">
          <input type="text" id="postCode" class="form-control" [(ngModel)]="data.postCode" placeholder="{{'DATA.DELIVERY-POSTALCODE'|translate}}">
          <label for="postCode">{{'DATA.DELIVERY-POSTALCODE'|translate}}</label>
          <span class="text-danger">{{ errors && errors.postCode }}</span>
        </div>

        <div class="dropdown-label-group">
          <p-dropdown
            class="dv-dropdown"
            selectId="country"
            [options]="countryList"
            [(ngModel)]="data.country"
            [autoDisplayFirst]="false"
            placeholder="{{'DATA.COUNTRY'|translate}}"
            [style]="{'z-index': 3}"
          >
          </p-dropdown>
          <label for="country">{{'DATA.COUNTRY'|translate}}</label>
          <span class="text-danger">{{ errors && errors.country }}</span>
        </div>

        <div class="form-label-group">
          <input type="text" id="taxID" class="form-control" maxlength="13" [(ngModel)]="data.taxID "
                 [placeholder]="isForeignCorporation ? 'Passport No.' : 'Tax ID'">
          <label for="taxID">{{ isForeignCorporation ? 'Passport No.' : 'Tax ID' }}</label>
          <span class="text-danger">{{ errorTaxID }}</span>
        </div>

        <div class="form-label-group">
          <input type="text" id="branchCode" class="form-control" [(ngModel)]="data.branchCode" placeholder="{{'TABLE.BRANCH-CODE'|translate}}">
          <!-- <p-dropdown
            class="dv-dropdown"
            selectId="branchCode"
            [options]="branchCodeList"
            [(ngModel)]="data.branchCode"
            [autoDisplayFirst]="true"
          >
          </p-dropdown> -->
          <label for="branchCode">{{'NORMAL.BRANCH-NAME-CODE'|translate}}</label>
          <span class="text-danger">{{ errors && errors.branchCode }}</span>
        </div>

<!--        <div class="form-label-group">-->
<!--          <input type="text" id="phoneNumber" class="form-control" [(ngModel)]="data.phoneNumber" placeholder="เบอร์โทรศัทท์">-->
<!--          <label for="phoneNumber">เบอร์โทรศัทท์</label>-->
<!--        </div>-->

        <div class="form-label-group">
          <input type="text" id="email" class="form-control" [(ngModel)]="data.email" placeholder="{{'EMAIL-DASHBOARD.EMAIL'|translate}}">
          <label for="email">{{'EMAIL-DASHBOARD.EMAIL'|translate}}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer m-b-0">
    <div class="col">
      <div class="row m-b-5">
        <!--<div class="col text-center text-red">{{ errorMessage ? errorMessage : '&nbsp;' }}</div>-->
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <button class="btn btn-dv btn-clean btn-wide m-r-20" (click)="modal.close()">
            {{'COMMON.CANCEL'|translate}}</button>
        </div>
        <button class="col-auto btn btn-dv btn-wide pull-right" (click)="submit()">
          {{ isCreate ? 'TEXT.SAVE' : 'NORMAL.EDIT'|translate}}</button>
      </div>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-detail/customer-detail.component.html